import $ from "jquery";
import { getStoreValue } from "@bd-stores";

/**
 * Add analytic view record
 * @param {string} event - Event name
 * @param {string} referenece - Reference name/path
 */
export default (event, reference) => {
  const page = window.location.pathname.replace(/\/$/, "").split("/").pop();

  $.ajax({
    url: window.__CFG__.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "analytic_view",
      nonce: window.__CFG__.nonce,
      event: event,
      reference: reference,
      page: page,
      building: getStoreValue("currentBuilding")?.name,
    },
  })
    .done(function () {})
    .fail(function () {
      console.error("ajax analytic view : an error occurred");
    })
    .always(function () {});
};
